import React, { useEffect, useState } from "react";
import "./AboutUsServices.css"; // Optional for custom CSS
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaCar, FaShieldAlt, FaKey, FaFileAlt } from "react-icons/fa"; // Font Awesome Icons
import bgLayout from "../../assets/img/aboutus/bgLayout.svg";

const services = [
  {
    icon: "car.svg",
    title: "Automobile Insurance",
    description:
      "Drive protected, drive assured: Your trusted auto insurance partner.",
  },
  {
    icon: "insurance.svg",
    title: "SR22 Insurance",
    description: "Keeping you on the road with confidence and compliance.",
  },
  {
    icon: "coverage.svg",
    title: "Personalized Coverage",
    description: "Designed to address the individual needs of each customer.",
  },
  {
    icon: "chart.svg",
    title: "Expert Advice",
    description: "Expert advice, just around the corner whenever you need.",
  },
  {
    icon: "agent.svg",
    title: "Products & Services",
    description: "Keeping you on the road with confidence and compliance.",
  },
  {
    icon: "dollar.svg",
    title: "Money-Saving Discounts",
    description: "Maximize your money with our discounts.",
  },
  {
    icon: "key.svg",
    title: "Non-Owner’s Policy",
    description: "Protect yourself with non-owner's auto insurance.",
  },
  {
    icon: "files.svg",
    title: "Commercial Auto Insurance",
    description: "Protect your fleet that protects every mile.",
  },
];

const AboutUsServices = () => {
  const [responsiveStatus, setResponsiveStatus] = useState(false);

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 480px)"),
      isMobile: window.matchMedia("(min-width: 481px) and (max-width: 767px)"),
      isTablet: window.matchMedia("(min-width: 768px) and (max-width: 1024px)"),
      isTabletLandscape: window.matchMedia(
        "(min-width: 1025px) and (max-width: 1279px)"
      ),
      isDesktop: window.matchMedia("(min-width: 1280px)"),
    };

    const updateResponsiveStatus = () => {
      const matchingBreakpoints = Object.entries(mediaQueries)
        .filter(([, mq]) => mq.matches)
        .map(([name]) => name);

      setResponsiveStatus(matchingBreakpoints[0]);
    };

    // Initial check
    updateResponsiveStatus();

    // Add media query listeners
    const mediaListeners = Object.values(mediaQueries).map((mq) => {
      mq.addEventListener("change", updateResponsiveStatus);
      return () => mq.removeEventListener("change", updateResponsiveStatus);
    });

    // Add window resize listener
    window.addEventListener("resize", updateResponsiveStatus);

    // Cleanup all listeners on unmount
    return () => {
      mediaListeners.forEach((remove) => remove());
      window.removeEventListener("resize", updateResponsiveStatus);
    };
  }, []);

  return (
    <div className="services-section py-5" style={styles.container}>
      <Container
        style={{
          maxWidth:
            responsiveStatus === "isDesktop"
              ? "1300px"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "1000px"
              : "1000px",
        }}
        className={`${
          responsiveStatus === "isDesktop"
            ? "text-center services-container"
            : responsiveStatus === "isTablet" ||
              responsiveStatus === "isTabletLandscape"
            ? "text-center services-container"
            : "text-left"
        }`}
      >
        {(responsiveStatus === "isMobile" ||
          responsiveStatus === "isSmallMobile") && (
          <p
            className="text-left heading mb-3"
            style={{ color: "#000", fontSize: "17px" }}
          >
            <span
              style={{
                borderBottom: "2px solid #0E72D6",
                paddingBottom: "8px",
              }}
            >
              Get started with us
            </span>
          </p>
        )}
        {responsiveStatus !== "isMobile" &&
          responsiveStatus !== "isSmallMobile" && (
            <p
              className="text-center heading mb-3"
              style={{ color: "#000", fontSize: "17px" }}
            >
              W
              <span
                style={{
                  borderBottom: "2px solid #0E72D6",
                  paddingBottom: "8px",
                }}
              >
                hat We Offe
              </span>
              r
            </p>
          )}

        <h2
          style={{
            color: "#000",
            fontWeight: 600,
            fontSize:
              responsiveStatus === "isDesktop"
                ? "30px"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "30px"
                : "16px",

            marginBottom: "20px",
            lineHeight: "100%",
          }}
        >
          {responsiveStatus === "isMobile" ||
          responsiveStatus === "isSmallMobile"
            ? "Secure your Journey with Confidence"
            : "Services at UAIC"}
        </h2>

        {(responsiveStatus !== "isMobile" ||
          responsiveStatus !== "isSmallMobile") && (
          <Row className="mt-5">
            {services.map((service, idx) => (
              <Col key={idx} md={3} lg={3} className="mb-4">
                <Card
                  style={{ minWidth: "inherit" }}
                  className="p-4 shadow-sm service-card text-center h-100"
                >
                  <div className="mb-3 mx-auto">
                    <img
                      src={require(`../../assets/img/aboutus/${service.icon}`)}
                      alt={service.title}
                      className="service-icon"
                    />
                  </div>
                  {/* <h5 className="serviceTitle">{service.title}</h5> */}
                  {service.title === "Commercial Auto Insurance" ? (
                    <span className="serviceTitle">
                      Commercial Auto <br /> Insurance
                    </span>
                  ) : service.title === "Money-Saving Discounts" ? (
                    <span className="serviceTitle">
                      Money Saving <br /> Discounts
                    </span>
                  ) : (
                    <span className="serviceTitle">{service.title}</span>
                  )}
                  <p className="serviceDescription">{service.description}</p>
                </Card>
              </Col>
            ))}
          </Row>
        )}
        {(responsiveStatus === "isMobile" ||
          responsiveStatus === "isSmallMobile") && (
          <Row className="mt-4">
            {services.map((service, idx) => (
              <Col key={idx} md={12} className="mb-2">
                <Card className="shadow-sm service-card h-100 d-flex flex-row align-items-center justify-content-start">
                  <div>
                    <img
                      src={require(`../../assets/img/aboutus/${service.icon}`)}
                      alt={service.title}
                      className="service-icon"
                    />
                  </div>
                  <div>
                    <span className="serviceTitle">{service.title}</span>
                    <p className="serviceDescription">{service.description}</p>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${bgLayout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    maxWidth: "1350px",
    margin: "0 auto",
  },
  container1: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
  },
};

export default AboutUsServices;
